export default {"src":"/_next/static/media/business12.a73f7c75.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};